var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.2,5.8c4,0.2,7.7,2.2,10.2,6.4c0.2,0.3,0.1,0.5,0,0.8c-2.2,3.6-5.3,5.8-9.5,6.2C8.5,19.7,4.3,17.5,1.5,13 c-0.2-0.3-0.2-0.5,0-0.8C3.8,8.2,7.9,5.8,13.2,5.8z M13,7.5c-4.1,0-7.6,1.8-9.5,4.6c-0.2,0.3-0.2,0.5,0,0.8c4.2,6.2,13.7,6.2,18,0 c0.2-0.3,0.2-0.5,0-0.7C19.2,9.1,16.2,7.6,13,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,12.7c-0.1,1.8-1.6,3.2-3.3,3.1c-1.8-0.1-3.2-1.6-3.1-3.4c0.1-1.8,1.6-3.2,3.4-3.1C14.4,9.5,15.7,10.9,15.6,12.7z  M14,12.6c0-0.9-0.6-1.6-1.5-1.6c-0.8,0-1.6,0.7-1.6,1.5c0,0.8,0.7,1.6,1.5,1.6C13.2,14.1,13.9,13.5,14,12.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/Open.b80fb72ee9288867bfd201c0eb89bd0e.svg";
export { ForwardRef as ReactComponent };